import stats from './stats'
import projCompare from './proj-compare'

export default {
    stats,
    projCompare
}



// WEBPACK FOOTER //
// ./src/api/statistics/index.js